import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { I18NextModule } from 'angular-i18next';
import i18next from 'i18next';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDialog } from '@angular/material/dialog';
import { StorageService } from '../../core/storage/storage.service';
import { RequestType } from 'src/app/shared/model/requestType.enum';
import { AuthorizerUsers, User } from '../../shared/model/user.model';
import { Vehicles, PccVehicle } from '../../shared/model/vehicle.model';
import {
  OrderRequest,
  PetitionerRequest,
  ReplacementVehicleRequest,
  RequestedNewVehicle
} from 'src/app/shared/model/order.model';
import { StepperComponent } from 'src/app/shared/components/stepper/stepper.component';
import { FeedbackModalComponent } from 'src/app/shared/components/feedback-modal/feedback-modal.component';
import { OrderService } from 'src/app/core/services/order.service';
import { UtilsService } from 'src/app/core/services/utils.service';

@Component({
  standalone: true,
  selector: 'app-employee-leasing-request',
  templateUrl: './employee-leasing-request.component.html',
  styleUrls: ['./employee-leasing-request.component.scss'],
  imports: [
    CommonModule,
    I18NextModule,
    RouterModule,
    MatFormFieldModule,
    StepperComponent
  ]
})
export class EmployeeLeasingRequestComponent implements OnInit {
  @ViewChild('stepperHeader') stepperHeader!: ElementRef;
  configCode = '';
  disableVehicle = false;
  existVehicles = false;
  vinNumberAssign = '';
  typeTranslation = '';
  user!: User;
  types!: RequestType;
  requestType = RequestType.leasing;
  vehicleInfoData!: PccVehicle;
  vehicleType = '';
  vehiclesArr: Vehicles[] = [];
  newRequest!: OrderRequest;
  orderType = '';
  spinner = false;
  removeData = false;
  pssFinalDate!: Date;
  data = '';
  isFirstAssign = false;
  retribution!: string;
  newVehicle?: RequestedNewVehicle;
  replacementVehicle?: ReplacementVehicleRequest | null;
  estimatedKmsData?: number;
  petitioner?: PetitionerRequest;
  requestSubtype = '';
  requestObj!: OrderRequest;
  ad?: boolean;
  newRequestType = '';
  isDetail = false;
  controller?: AuthorizerUsers;
  extraEmail = '';
  extraPhone = '';
  selectedVehicleType = 'configurator';
  stockVehicle?: Vehicles;
  leaseEndowType = 'empty';

  //errores
  nisError = false;
  addDataError = '';
  isKmsExceeded = false;
  errorPcc = false;
  errorPccText = '';
  errorKms = false;
  errorNisFunction = false;
  errorNisFunctionText = '';
  //Stepper
  isLinear = true;

  steps = new Map<string, boolean>();

  landing2 = false;
  requestCarType = null;
  isVip = false;
  loading = false;
  isPhone = false;

  constructor(
    private storageService: StorageService,
    private orderService: OrderService,
    public dialog: MatDialog,
    private router: Router,
    private utilsService: UtilsService
  ) {}

  ngOnInit(): void {
    this.isPhone = this.utilsService.isPhone();
    this.landing2 = this.storageService.get('landing2') || false;
    this.requestCarType = this.storageService.get('requestCarType') || null;
    this.storageService.set('navigation', 'newRequest');
    this.user = this.storageService.get('config');
    if (this.storageService.get('ad')) {
      this.ad = this.storageService.get('ad');
    }
    if (this.ad === true) {
      this.router.navigateByUrl('/landing');
    }
  }

  @HostListener('window:resize')
  onResize() {
    if (this.leaseEndowType !== 'empty') {
      this.adjustStepper();
    }
  }

  setLeaseEndowSteps(type: string) {
    this.leaseEndowType = type;
    this.setSteps();
    setTimeout(() => {
      this.adjustStepper();
    }, 100);
  }

  sendRequest(newRequestData: any) {
    this.loading = true;
    this.orderService.createLeasing(newRequestData).subscribe({
      next: () => {
        this.loading = false;
        if (newRequestData && newRequestData.leasingData) {
          const queryParams = {
            orderType: 'Secondaryleasing',
            substitutionRequestNumber: newRequestData.leasingData
              .replacedVehicle
              ? newRequestData.leasingData.replacedVehicle?.requestNumber
              : null
          };
          this.router.navigate(['request-completed'], { queryParams });
        }
      },
      error: (errorResponse) => {
        this.loading = false;
        const errorBody = errorResponse.error;
        const errorMessage = errorBody?.message;
        if (errorMessage?.includes('VEHICLE_BLOCKED')) {
          this.dialog.open(FeedbackModalComponent, {
            data: {
              text: i18next.t('vehicleBlocked'),
              close: true,
              theme: 'ligth'
            },
            disableClose: true
          });
        } else {
          this.dialog.open(FeedbackModalComponent, {
            data: {
              text: i18next.t('newRequestKO'),
              close: true,
              theme: 'ligth'
            },
            disableClose: true
          });
        }
      }
    });
  }

  setSteps() {
    if (this.leaseEndowType === 'stock') {
      this.steps.set('approvers', false);
      this.steps.set('request-info', false);
      this.steps.set('stockVehicle', true);
      this.steps.set('car-config', false);
      this.steps.set('replacementvehicle', false);
      this.steps.set('uploadDocuments', true);
      this.steps.set('additionalInfo', true);
      this.steps.set('resume', true);
    } else if ((this.leaseEndowType = 'config')) {
      this.steps.set('approvers', false);
      this.steps.set('request-info', false);
      this.steps.set('stockVehicle', false);
      this.steps.set('car-config', true);
      this.steps.set('replacementvehicle', false);
      this.steps.set('uploadDocuments', true);
      this.steps.set('additionalInfo', true);
      this.steps.set('resume', true);
    } else {
      this.steps.set('approvers', false);
      this.steps.set('request-info', true);
      this.steps.set('car-config', true);
      this.steps.set('replacementvehicle', true);
      this.steps.set('uploadDocuments', true);
      this.steps.set('additionalInfo', true);
    }
  }

  adjustStepper() {
    const stepperHeaderContainer: any = document.querySelector(
      '.mat-horizontal-stepper-header-container'
    );
    if (stepperHeaderContainer) {
      //scale 0.8
      stepperHeaderContainer.style.transform = 'scale(0.8)';
      stepperHeaderContainer.style.transformOrigin = 'center right';

      const offY = stepperHeaderContainer.offsetHeight / 2;

      const stepperHeader = this.stepperHeader.nativeElement;
      const x = stepperHeader.getBoundingClientRect().x;

      const right = window.innerWidth - x;
      stepperHeaderContainer.style.position = 'absolute';
      stepperHeaderContainer.style.top = stepperHeader.offsetTop - offY + 'px';
      stepperHeaderContainer.style.right = right + 'px';
    }
    if (stepperHeaderContainer && window.innerWidth <= 1024) {
      stepperHeaderContainer.style.transformOrigin = 'center left';
      stepperHeaderContainer.style['flex-wrap'] = 'wrap';
      stepperHeaderContainer.style.position = 'unset';
    }
  }

  initial() {
    this.leaseEndowType = 'empty';
    this.steps = new Map<string, boolean>();
  }
}
